import { Modal } from '@mantine/core';
import { useMounted } from '@mantine/hooks';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from 'shared/lib';
import { highrollersModalModel } from '../../model';
import { HighrollersModalTable } from '../highrollers-modal-table';
import cls from './highrollers-modal.module.scss';

export type HighrollersModalProps = {
	targetId: string;
};

export const HighrollersModal = ({ targetId }: HighrollersModalProps) => {
	const { t } = useTranslation();
	const mounted = useMounted();

	const [opened, close] = useUnit([
		highrollersModalModel.highrollersSwitcher.$active,
		highrollersModalModel.highrollersSwitcher.disable,
	]);

	const sm = useBreakpoint('sm', false);

	return (
		mounted && (
			<Modal
				classNames={{
					overlay: cls.highrollersModalOverlay,
					inner: cls.highrollersModalInner,
					content: cls.highrollersModalContent,
					body: cls.highrollersModalBody,
				}}
				title={t('highrollers-modal.title')}
				opened={opened}
				portalProps={{
					target: document.getElementById(targetId)!,
				}}
				size={sm ? 'md' : 'sm'}
				onClose={close}
			>
				<HighrollersModalTable />
			</Modal>
		)
	);
};
